import React, { useContext } from 'react';
import contacttitlear from '../../../Assets/Images/Home/contacttitlear.png'
import contacttitleen from '../../../Assets/Images/Home/contacttitleen.png'
import contactar from '../../../Assets/Images/Home/contactar.png'
import contacten from '../../../Assets/Images/Home/contacten.png'
import contactBGar from '../../../Assets/Images/Home/contactBGar.png'
import contactBGen from '../../../Assets/Images/Home/contactBGen.png'
import String from '../../../Assets/Localization/Local'
import { LangContext } from '../../../App'
import { Inputs, Validation, config } from './config.js'
import Field from '../../../Components/Fields/Fields'

const ContactUS = () => {

  const { lang } = useContext(LangContext);


  String.setLanguage(lang);

  const btnLoginStyle = {
    width: '100%',
    padding: '13px',
    borderRadius: '36px',
    margin: '0 auto',
    outline: 'none',
    border: 'none',
    backgroundImage: 'radial-gradient(#F1AA57, #F6921E)',
  }
  const dimButton = {
    backgroundColor: '#d7d7d7',
    width: '100%',
    padding: '13px',
    borderRadius: '36px',
    margin: '0 auto',
    outline: 'none',
    border: 'none',
  }

  return (
    <div className="ContactUS">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-7">
            <div className="HomeTitle">
              <img src={lang === "ar" ? contacttitlear : contacttitleen} alt="titleBG" />
              <h2 style={{ transform: lang === "ar" ? "translate(-35%, 70%)" : "translate(8%, 65%)" }}>{String.contactUs}</h2>
            </div>
            <div className="contactform mt-4 mt-xl-5">
              <Field inputs={Inputs} validation={Validation} fromcontactus={true} config={config} SubmitBtnStyle={btnLoginStyle} dimButton={dimButton}/>
            </div>
          </div>
          <div className="col-md-5 d-none d-md-block">
            <div className="contactimg" style={{ backgroundImage: lang === "ar" ? `url(${contactBGar})` : `url(${contactBGen})` }}>
              <img src={lang === "ar" ? contactar : contacten} alt="aboutBG" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUS;
